import { useCallback, useRef, useState } from 'react'

export const MAX_RECENT_PROJECTS = 3

const storageKey = userId => `locasty_recent_projects_${userId}`

function readRecentProjectIds(userId) {
  if (!userId) return []
  try {
    const ids = JSON.parse(localStorage.getItem(storageKey(userId)) || '[]')
    return Array.isArray(ids) ? ids : []
  } catch (error) {
    return []
  }
}

function useRecentProjects(userId) {
  const [recentProjectIds, setRecentProjectIds] = useState(() =>
    readRecentProjectIds(userId)
  )
  const [loadedUserId, setLoadedUserId] = useState(userId)

  if (loadedUserId !== userId) {
    setLoadedUserId(userId)
    setRecentProjectIds(readRecentProjectIds(userId))
  }

  const historyRef = useRef({ userId, ids: recentProjectIds })
  const addRecentProject = useCallback(
    projectId => {
      if (!userId || !projectId) return
      if (historyRef.current.userId !== userId) {
        historyRef.current = { userId, ids: readRecentProjectIds(userId) }
      }
      const nextIds = [
        projectId,
        ...historyRef.current.ids.filter(id => id !== projectId),
      ].slice(0, MAX_RECENT_PROJECTS + 1)

      historyRef.current = { userId, ids: nextIds }
      setRecentProjectIds(nextIds)
      try {
        localStorage.setItem(storageKey(userId), JSON.stringify(nextIds))
      } catch (error) {}
    },
    [userId]
  )

  return [recentProjectIds, addRecentProject]
}

export default useRecentProjects
